const InviteUser = async (userDisplayName, email, code) => {
  const mailOptions = {
    to: email,
    subject: `${userDisplayName} from Lookflock`,
    html: `<p>Hello!</p>
        <p>Your friend ${userDisplayName} is inviting you to join <a href=${code}>Lookflock.com</a>, a social shopping platform for all things fashion.</p>
        <p>As a user, you can:</p>
        <ol>
          <li><b>Discover Fashion Trends:</b> Explore curated collections and find inspiration.</li>
          <li><b>Create & Share Wishlists:</b> Showcase must-haves and get personalized recommendations.</li>
          <li><b>Connect with Our Community:</b> Engage with fellow fashion enthusiasts, bloggers, designers, and stylists.</li>
        </ol>
        <p>Please note that the site is still in development, so you might encounter some incomplete sections and broken functionality.</p>
        <p>We encourage you to share your feedback with us <a href="https://www.lookflock.com/#/contactUs">here</a> or by replying to this email, as it helps us greatly to improve our functionality and provide a better experience for our users.</p>
        <p>Click here to join the fun: ${code}<br>
        <p>Best regards,<br>
        The Lookflock Team<br>
        <a href="https://www.lookflock.com">https://www.lookflock.com</a></p>
        <p>P.S. Don't forget to complete your profile to get the most personalized experience!</p>,`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sentt:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};

const GetFeedBack = async (
  userDisplayName,
  displayName,
  email,
  code,
  message
) => {
  const mailOptions = {
    to: email,
    subject: `${userDisplayName} needs your feedback`,
    html: `<p>Hello ${displayName}!</p>
        <p>${
          message === ""
            ? `I need your feedback on this product. <a href=${code}>Check it out!</a>`
            : message
        } <br>
        Here's the Product Link: <a href=${code}>${code}</a>
        </p>
        <p>Best regards,<br>
        ${userDisplayName}<br>`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sentt:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};
const ShoppingListMail = async (
  myName,
  email,
  shoppingListName,
  link,
  productImgUrls,
  profile,
  content
) => {
  const mailOptions = {
    to: email,
    subject:
      myName +
      " is inviting you to checkout his " +
      shoppingListName +
      " shopping list",
    html: `<p>Hey,</p>
      <p>Checkout my shopping list: ${link}</p>
      <p>Lookflock team</p>
      <a href=${link}>
      <div
    style="margin: 2px;margin-top: 1px;background-color: #f2f4f7;box-shadow: 1px 1px 10px 0px; padding: 20px;border-radius: 10px;width: 50vw;"
  >
    <div style="display: flex;align-items: center;width: 100%;">
      <div style="height: 50px;width: 50px;">
        <a href="${
          link.split("#")[0]
        }#/userProfile/2owZ9Nyd9gauVFtCiGi8W6kHcj72" target="_blank">
          <img
            src=${profile}
            alt=""
            style="cursor: default;object-fit: cover;border-radius: 8px;width: 100%;height: 100%;"
          />
        </a>
      </div>
      <table
        style="background-color: white; width: 100%; border-radius: 10px; border-collapse: collapse; padding: 10px;"
      >
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <h4 style="margin: 0;">${shoppingListName}</h4>
            <h5 style="margin: 0; font-weight: lighter;">
              <a
                style="text-decoration: none; color: rgb(103, 106, 121);"
                href="${
                  link.split("#")[0]
                }#/userProfile/2owZ9Nyd9gauVFtCiGi8W6kHcj72"
                >by <i>${myName}</i></a
              >
            </h5>
          </td>
          <td style="padding: 10px; vertical-align: top; text-align: right;">
            <span style="font-size: small;">5 min ago</span>
          </td>
        </tr>
      </table>
    </div>
    <div
      style="padding: 0.5rem;background-color: white;margin: 0.5rem 0;border-radius: 10px;"
    >
      <p>
        Hello! I am posting my favorites shopping list. These are the products
        that I like and want everyone to know about.
      </p>
      <div style="display: flex;overflow-x: auto;">
        ${productImgUrls
          .map(
            (product) =>
              `<div style=" display: inline-block;outline: none;">
          <div
            style="display: flex;flex-direction: column;padding: 0.5rem;padding-bottom: 0;"
          >
            <div style="position: relative;">
              <a
                href="${link.split("#")[0]}#/ProductDetails/${product?.id}"
                style="text-decoration: none;"
              >
                <img
                  style="object-fit: cover;height: 13.5rem;border-radius: 5px;"
                  src=${product?.image}
                />
              </a>
            </div>
          </div>
        </div>`
          )
          .join("")}
      </div>
    </div>
  </div>
  </a>`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sent:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};

const CustomShoppingListMail = async (
  myName,
  email,
  shoppingListName,
  link,
  productImgUrls,
  profile,
  content
) => {
  const mailOptions = {
    to: email,
    subject:
      myName +
      " is inviting you to checkout his " +
      shoppingListName +
      " shopping list",
    html: `<p>Hey,</p>
      <p>${content}: ${link}</p>
      <p>Lookflock team</p>
      <a href=${link}>
      <div
    style="margin: 2px;margin-top: 1px;background-color: #f2f4f7;box-shadow: 1px 1px 10px 0px; padding: 20px;border-radius: 10px;width: 50vw;"
  >
    <div style="display: flex;align-items: center;width: 100%;">
      <div style="height: 50px;width: 50px;">
        <a href="${
          link.split("#")[0]
        }#/userProfile/2owZ9Nyd9gauVFtCiGi8W6kHcj72" target="_blank">
          <img
            src=${profile}
            alt=""
            style="cursor: default;object-fit: cover;border-radius: 8px;width: 100%;height: 100%;"
          />
        </a>
      </div>
      <table
        style="background-color: white; width: 100%; border-radius: 10px; border-collapse: collapse; padding: 10px;"
      >
        <tr>
          <td style="padding: 10px; vertical-align: top;">
            <h4 style="margin: 0;">${shoppingListName}</h4>
            <h5 style="margin: 0; font-weight: lighter;">
              <a
                style="text-decoration: none; color: rgb(103, 106, 121);"
                href="${
                  link.split("#")[0]
                }#/userProfile/2owZ9Nyd9gauVFtCiGi8W6kHcj72"
                >by <i>${myName}</i></a
              >
            </h5>
          </td>
          <td style="padding: 10px; vertical-align: top; text-align: right;">
            <span style="font-size: small;">5 min ago</span>
          </td>
        </tr>
      </table>
    </div>
    <div
      style="padding: 0.5rem;background-color: white;margin: 0.5rem 0;border-radius: 10px;"
    >
      <p>
        Hello! I am posting my favorites shopping list. These are the products
        that I like and want everyone to know about.
      </p>
      <div style="display: flex;overflow-x: auto;">
        ${productImgUrls
          .map(
            (product) =>
              `<div style=" display: inline-block;outline: none;">
          <div
            style="display: flex;flex-direction: column;padding: 0.5rem;padding-bottom: 0;"
          >
            <div style="position: relative;">
              <a
                href="${link.split("#")[0]}#/ProductDetails/${product?.id}"
                style="text-decoration: none;"
              >
                <img
                  style="object-fit: cover;height: 13.5rem;border-radius: 5px;"
                  src=${product?.image}
                />
              </a>
            </div>
          </div>
        </div>`
          )
          .join("")}
      </div>
    </div>
  </div>
  </a>`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sent:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};
const UserMessage = async (
  senderName,
  recieverName,
  email,
  profile,
  content
) => {
  const mailOptions = {
    to: email,
    subject: senderName + " sent you a message ",
    html: `<p>Hey ${recieverName} ,</p>
      <p>Lookflock team</p>
   
   
  </a>`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sent:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};
const WelcomeUser = async (displayName, email) => {
  const mailOptions = {
    to: email,
    subject: "Welcome to Lookflock - Social Shopping!",
    html: `<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    /* Fallback fonts */
    body,
    td {
      font-family: 'Inter';
    }

    .cardElement {
      padding: 0.75rem 1rem;
    }

    .headerText {
      font-size: 1.375rem;
    }

    .encourageText {
      font-size: 1rem;
    }

    .desktopOnly {
      display: none;
    }

    .mobileOnly {
      display: block;
    }

    .psText {
      font-size: 0.875rem;
    }

    @media (min-width: 747px) {
      .headerText {
        font-size: 1.25rem;
      }

      .cardElement {
        padding: 1.5rem;
      }

      .desktopOnly {
        display: block;
      }

      .mobileOnly {
        display: none;
      }

      .encourageText {
        font-size: 1rem;
      }

      .psText {
        font-size: 1rem;
      }
    }
  </style>
</head>

<body style="margin: 0;padding: 0;">
  <!-- main -->
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color: #FFFFFF;">
    <tr>
      <td align="center">
        <table role="presentation" class="container" width="600" cellspacing="16px" cellpadding="0" border="0"
          style="width: 100%; max-width: 100%;-webkit-border-horizontal-spacing: 0px">
          <tr>
            <td align="center" class="headerText" style="font-family: Inter; ">

              <img
                src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fimage%205.png?alt=media&token=e839e431-8a8a-4064-9c4b-a4e3577c0735" />
              <br />
              Welcome <strong>${displayName}</strong>,
            </td>
          </tr>
          <tr>
            <td>
              <table role="presentation" width="100%" cellspacing="0" cellpadding="10"
                style="font-family: Inter;background-color: #ffffff;padding: 10px;-webkit-border-vertical-spacing: 0px;">
                <tr>
                  <td style="padding: 0;">
                    <table role="presentation" width="100%" cellspacing="10px" cellpadding="0"
                      style="max-width: 620px; margin: auto;-webkit-border-horizontal-spacing:0px">
                      <!-- Mobile View Cards -->
                      <tr>
                        <td valign="top" class="cardElement mobileOnly"
                          style="background-color: #E2F8FF; border-radius: 1rem;">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FDiscover%20(2).png?alt=media&token=b823947e-7b83-4cec-848b-a24bc48f5707"
                                  width="42" height="42" alt="Discover" />
                                <br />
                                <div style="text-align: center; display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1rem;">Discover Trends</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem">Get Personalised</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td valign="top" class="cardElement mobileOnly"
                          style="background-color: #F5FFEE; border-radius: 1rem; ">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FShoppinglist.png?alt=media&token=0957230a-427c-46c0-a681-7acdad45de7c"
                                  width="42" height="42" alt="Shopping List" />
                                <br />
                                <div style="text-align: center; display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1rem;">Create Shopping Lists</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem;">Save Products you Like</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td valign="top" class="cardElement mobileOnly"
                          style="background-color: #FFEEF4; border-radius: 1rem;">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FFeedback.png?alt=media&token=3ba677a4-5d22-47fd-98a4-53f707e1261a"
                                  width="42" height="42" alt="Feedback" />
                                <br />
                                <div style="text-align: center; display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1rem;">Get Feedback</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem;">Ask Friends what to Buy</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <!-- Desktop View Cards -->
                      <tr class="desktopOnly" style="padding: 0; margin-top: -40px;">
                        <td valign="top" class="cardElement"
                          style="background-color: #E2F8FF; border-radius: 1rem; width: 34%; padding: 1rem; ">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FDiscover%20(2).png?alt=media&token=b823947e-7b83-4cec-848b-a24bc48f5707"
                                  width="42" height="42" alt="Discover" />
                                <br />
                                <div style="display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1.125rem;">Discover Trends</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem;">Get Personalised</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td style="width: 1.33%;"></td> <!-- Spacer column -->
                        <td valign="top" class="cardElement"
                          style="background-color: #F5FFEE; border-radius: 1rem; width: 34%; padding: 1rem; ">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FShoppinglist.png?alt=media&token=0957230a-427c-46c0-a681-7acdad45de7c"
                                  width="42" height="42" alt="Discover" />
                                <br />
                                <div style="text-align: center; display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1.125rem;">Create Shopping Lists</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem;">Save Products you Like</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td style="width: 1.33%;"></td> <!-- Spacer column -->
                        <td valign="top" class="cardElement"
                          style="background-color: #FFEEF4; border-radius: 1rem; width: 34%; padding: 1rem;">
                          <table role="presentation" cellspacing="0" cellpadding="0" width="100%">
                            <tr>
                              <td style="text-align: center;">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2FFeedback.png?alt=media&token=3ba677a4-5d22-47fd-98a4-53f707e1261a"
                                  width="42" height="42" alt="Feedback" />
                                <br />
                                <div style="display: inline-block; margin-bottom: 0.25rem;">
                                  <strong style="font-size: 1.125rem;">Get Feedback</strong>
                                </div>
                                <br />
                                <span style="color: #5E676A; font-size: 0.875rem;">Ask Friends what to Buy</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>

                      <!-- Common Elements -->
                      <tr>
                        <td style="padding: 0;">
                          <a href="www.lookflock.com"
                            style="display: block; padding: 0.75rem 2rem; border: 1px solid #005FDA; color: #005FDA; text-decoration: none; border-radius: 0.75rem; font-weight: 500; font-size: 1rem;text-align: center;">Explore
                            Lookflock</a>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" class="psText" style="color: #676A79; padding: 0.375rem 0px 0.375rem 0px;">
                          <strong style="color: #000;">P.S.</strong> Please
                          note that the site is still in development, so you
                          might encounter some incomplete sections and broken
                          functionality.
                        </td>
                      </tr>
                      <tr>
                        <td align="center" class="psText"
                          style="color: #676A79;  padding-top: 0px; padding-bottom: 0px;">
                          Need help? Just reply to this email and we'll be
                          happy to assist you.<br />
                          <a href="https://lookflock.com" style="color: #2375E2;">https://lookflock.com</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center" style="background-color: #ffffff;">
              <table role="presentation" width="100%" cellspacing="16px" cellpadding="0"
                style="text-align: center; font-family: Inter; max-width: 351px;">
                <tr>
                  <td>
                    <div style="background-color: #1DA1F21A;border-radius: 50%; height: 3rem; width: 3rem;margin: auto">
                      <img
                        src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Flinkedin.png?alt=media&token=a485b085-2944-49ce-a006-51231a09f952"
                        alt="Linkedin" width="25" style="margin-top: 11px; margin-left: 0.125rem;" />
                    </div>
                    <div style="color: #0077B7; font-size: 0.75rem; margin-top: 0.5rem;">
                      LinkedIn
                    </div>
                  </td>
                  <td>
                    <div style="background-color: #FFEDFA;border-radius: 50%; height: 3rem; width: 3rem;margin: auto">
                      <img
                        src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Finstagram.png?alt=media&token=c44cacae-1931-451c-b74f-93522177886b"
                        alt="Instagram" width="28" style="margin-top: 0.625rem;" />
                    </div>
                    <div style="color: #CF3DAB; font-size: 0.75rem; margin-top: 0.5rem;">
                      Instagram
                    </div>
                  </td>
                  <td>
                    <div style="
                        background-color: #1877F21A;
                        border-radius: 50%;
                        height: 3rem;
                        width: 48.85px;
                        margin: auto">
                      <img
                        src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Ffacebook.png?alt=media&token=29ea229f-463f-4e2e-a71b-a6be53151d98"
                        alt="Facebook" width="12.85" height="24" style="margin-top: 0.75rem;" />
                    </div>
                    <div style="color: #1877F2; font-size: 0.75rem; margin-top: 0.5rem;">
                      Facebook
                    </div>
                  </td>
                  <td>
                    <div style="
                        background-color: #25D3661A;
                        border-radius: 50%;
                        height: 3rem;
                        width: 3rem;
                        margin: auto">
                      <img
                        src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fwhatsapp.png?alt=media&token=cf1645b5-11d5-478e-9e7b-e67a6ec03322"
                        alt="WhatsApp" width="24" style="margin-top: 0.688rem;" />
                    </div>
                    <div style="color: #25D366; font-size: 0.75rem; margin-top: 0.5rem;">
                      WhatsApp
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" style="color: #000; 
                      padding: 0px; 
                      font-family: Inter;
                      font-weight: 400;
                      font-size: 0.875rem;
                      line-height: 100%;
                      letter-spacing: 0%;
                      text-align: center;
                      ">
                    Copyright © 2025, Lookflock
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>`,
  };

  try {
    const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(mailOptions),
    });

    const data = await response.json();
    console.log("Email sent:", data.message);
  } catch (error) {
    console.error("Error sending email:", error);
  }
};
// const WelcomeUser = async (displayName, email) => {
//   const mailOptions = {
//     to: email,
//     subject: "Welcome to Lookflock - Social Shopping!",
//     html: `<head>
//     <meta charset="UTF-8" />
//     <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//     <style>
//       .cardElement {
//         padding: 0.75rem 1rem;
//       }
//       .headerText {
//         font-size: 1.375rem;
//       }
//       .encourageText {
//         font-size: 1rem;
//       }
//       .desktopOnly {
//         display: none;
//       }
//       .mobileOnly {
//         display: block;
//       }
//       .psText {
//         font-size: 0.875rem;
//       }
//       @media (min-width: 747px) {
//         .headerText {
//           font-size: 1.25rem;
//         }
//         .cardElement {
//           padding: 1.5rem;
//         }
//         .desktopOnly {
//           display: block;
//         }
//         .mobileOnly {
//           display: none;
//         }
//         .encourageText {
//           font-size: 1rem;
//         }
//         .psText {
//           font-size: 1rem;
//         }
//       }
//     </style>
//   </head>

//   <body style="margin: 0;padding: 0;">
//     <!-- main -->
//     <table
//       role="presentation"
//       width="100%"
//       cellspacing="0"
//       cellpadding="0"
//       border="0"
//       style="background-color: #EAF0F3;"
//     >
//       <tr>
//         <td align="center">
//           <table
//             role="presentation"
//             class="container"
//             width="600"
//             cellspacing="16px"
//             cellpadding="0"
//             border="0"
//             style="width: 100%; max-width: 90%;-webkit-border-horizontal-spacing: 0px"
//           >
//             <tr>
//               <td
//                 align="center"
//                 class="headerText"
//                 style="font-family: sans-serif; "
//               >
//                 Hello <strong>Asad Furqan</strong>,<br />
//                 Welcome to <strong>Lookflock</strong>
//               </td>
//             </tr>
//             <tr>
//               <td>
//                 <table
//                   role="presentation"
//                   width="100%"
//                   cellspacing="0"
//                   cellpadding="10"
//                   style="font-family: sans-serif;background-color: #ffffff;padding: 10px;-webkit-border-vertical-spacing: 0px;"
//                 >
//                   <tr>
//                     <td style="padding: 0;">
//                       <table
//                         role="presentation"
//                         width="100%"
//                         cellspacing="10px"
//                         cellpadding="10"
//                         style="max-width: 620px; margin: auto;-webkit-border-horizontal-spacing:0px"
//                       >
//                         <tr>
//                           <td
//                             valign="top"
//                             class="cardElement mobileOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;"
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="60">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fdiscover.png?alt=media&token=70c920c4-b31c-4c3c-ac21-e0a6dcb52e91"
//                                     width="42"
//                                     height="42"
//                                     alt="Discover"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1rem;"
//                                       >Discover Trends</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A; font-size: 0.875rem"
//                                     >Explore curated collections and get
//                                     inspired</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                           <td
//                             valign="top"
//                             class="cardElement desktopOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;
//                             padding-top: 1.5rem;
//                             padding-right: 2.5rem;
//                             padding-bottom: 1.5rem;
//                             padding-left: 2.5rem;
//                             "
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="66">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fdiscover.png?alt=media&token=70c920c4-b31c-4c3c-ac21-e0a6dcb52e91"
//                                     width="50"
//                                     height="50"
//                                     alt="Discover"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1.25rem;"
//                                       >Discover Trends</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A;font-size: 1.125rem"
//                                     >Explore curated collections and get
//                                     inspired</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             valign="top"
//                             class="cardElement mobileOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;"
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="60">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fwishlist.png?alt=media&token=3ab12da3-055e-491a-b460-6491fb3cbfae"
//                                     width="42"
//                                     height="42"
//                                     alt="Wishlist"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1rem;"
//                                       >Create & Share Wishlists</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A; font-size: 0.875rem;"
//                                     >Showcase must haves and receive
//                                     recommendations</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                           <td
//                             valign="top"
//                             class="cardElement desktopOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;
//                             padding-top: 1.5rem;
//                             padding-right: 2.5rem;
//                             padding-bottom: 1.5rem;
//                             padding-left: 2.5rem;
//                             "
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="66">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fwishlist.png?alt=media&token=3ab12da3-055e-491a-b460-6491fb3cbfae"
//                                     width="50"
//                                     height="50"
//                                     alt="Discover"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1.25rem;"
//                                       >Create & Share Wishlists</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A;font-size: 1.125rem"
//                                     >Showcase must haves and receive
//                                     recommendations</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             valign="top"
//                             class="cardElement mobileOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;"
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="60">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fcollaborate.png?alt=media&token=e4212218-925b-49af-a177-8a238036415f"
//                                     width="42"
//                                     height="42"
//                                     alt="Collaborate"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1rem;"
//                                       >Collaborate and Connect</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A; font-size: 0.875rem;"
//                                     >Engage with fellow fashion
//                                     enthusiasts</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                           <td
//                             valign="top"
//                             class="cardElement desktopOnly"
//                             style="background-color: #EAF0F3; border-radius: 1rem;
//                             padding-top: 1.5rem;
//                             padding-right: 2.5rem;
//                             padding-bottom: 1.5rem;
//                             padding-left: 2.5rem;
//                             "
//                           >
//                             <table
//                               role="presentation"
//                               cellspacing="0"
//                               cellpadding="0"
//                               width="100%"
//                             >
//                               <tr>
//                                 <td width="66">
//                                   <img
//                                     src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fcollaborate.png?alt=media&token=e4212218-925b-49af-a177-8a238036415f"
//                                     width="50"
//                                     height="50"
//                                     alt="Discover"
//                                   />
//                                 </td>
//                                 <td>
//                                   <div
//                                     style="display: inline-block; margin-bottom: 0.25rem;"
//                                   >
//                                     <strong style="font-size: 1.25rem;"
//                                       >Collaborate and Connect</strong
//                                     >
//                                   </div>
//                                   <br />
//                                   <span
//                                     style="color: #5E676A;font-size: 1.125rem"
//                                     >Engage with fellow fashion
//                                     enthusiasts</span
//                                   >
//                                 </td>
//                               </tr>
//                             </table>
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             align="center"
//                             class="encourageText"
//                             style="color: #676A79;  padding: 0.375rem 0px 0.375rem 0px;"
//                           >
//                             We encourage you to share your feedback with us here
//                             or by replying to this email, as it helps us greatly
//                             to improve our functionality and provide a better
//                             experience for our users.
//                           </td>
//                         </tr>
//                         <tr>
//                           <td style="padding: 0;">
//                             <a
//                               href="www.lookflock.com"
//                               style="display: block; padding: 0.75rem 2rem; background-color: #005FDA; color: #fff; text-decoration: none; border-radius: 0.75rem; font-weight: 500; font-size: 1rem;text-align: center;"
//                               >Explore Lookflock</a
//                             >
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             align="center"
//                             class="psText"
//                             style="color: #676A79; padding: 0.375rem 0px 0.375rem 0px;"
//                           >
//                             <strong style="color: #000;">P.S.</strong> Please
//                             note that the site is still in development, so you
//                             might encounter some incomplete sections and broken
//                             functionality.
//                           </td>
//                         </tr>
//                         <tr>
//                           <td
//                             align="center"
//                             class="psText"
//                             style="color: #676A79;  padding-top: 0px; padding-bottom: 0px;"
//                           >
//                             Need help? Just reply to this email and we'll be
//                             happy to assist you.<br />
//                             <a
//                               href="https://lookflock.com"
//                               style="color: #2375E2;"
//                               >https://lookflock.com</a
//                             >
//                           </td>
//                         </tr>
//                       </table>
//                     </td>
//                   </tr>
//                 </table>
//               </td>
//             </tr>
//             <tr>
//               <td align="center" style="background-color: #ffffff;">
//                 <table
//                   role="presentation"
//                   width="100%"
//                   cellspacing="16px"
//                   cellpadding="0"
//                   style="text-align: center; font-family: sans-serif; max-width: 351px;"
//                 >
//                   <tr>
//                     <td>
//                       <div
//                         style="background-color: #1DA1F21A;border-radius: 50%; height: 3rem; width: 3rem;margin: auto"
//                       >
//                         <img
//                           src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Flinkedin.png?alt=media&token=a485b085-2944-49ce-a006-51231a09f952"
//                           alt="Linkedin"
//                           width="25"
//                           style="margin-top: 11px; margin-left: 0.125rem;"
//                         />
//                       </div>
//                       <div
//                         style="color: #0077B7; font-size: 0.75rem; margin-top: 0.5rem;"
//                       >
//                         LinkedIn
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style="background-color: #FFEDFA;border-radius: 50%; height: 3rem; width: 3rem;margin: auto"
//                       >
//                         <img
//                           src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Finstagram.png?alt=media&token=c44cacae-1931-451c-b74f-93522177886b"
//                           alt="Instagram"
//                           width="28"
//                           style="margin-top: 0.625rem;"
//                         />
//                       </div>
//                       <div
//                         style="color: #CF3DAB; font-size: 0.75rem; margin-top: 0.5rem;"
//                       >
//                         Instagram
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style="
//                         background-color: #1877F21A;
//                         border-radius: 50%;
//                         height: 3rem;
//                         width: 48.85px;
//                         margin: auto"
//                       >
//                         <img
//                           src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Ffacebook.png?alt=media&token=29ea229f-463f-4e2e-a71b-a6be53151d98"
//                           alt="Facebook"
//                           width="12.85"
//                           height="24"
//                           style="margin-top: 0.75rem;"
//                         />
//                       </div>
//                       <div
//                         style="color: #1877F2; font-size: 0.75rem; margin-top: 0.5rem;"
//                       >
//                         Facebook
//                       </div>
//                     </td>
//                     <td>
//                       <div
//                         style="
//                         background-color: #25D3661A;
//                         border-radius: 50%;
//                         height: 3rem;
//                         width: 3rem;
//                         margin: auto"
//                       >
//                         <img
//                           src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/welcomeEmail%2Fwhatsapp.png?alt=media&token=cf1645b5-11d5-478e-9e7b-e67a6ec03322"
//                           alt="WhatsApp"
//                           width="24"
//                           style="margin-top: 0.688rem;"
//                         />
//                       </div>
//                       <div
//                         style="color: #25D366; font-size: 0.75rem; margin-top: 0.5rem;"
//                       >
//                         WhatsApp
//                       </div>
//                     </td>
//                   </tr>
//                   <tr>
//                     <td
//                       colspan="4"
//                       style="color: #000;
//                       padding: 0px;
//                       font-family: sans-serif;
//                       font-weight: 400;
//                       font-size: 0.875rem;
//                       line-height: 100%;
//                       letter-spacing: 0%;
//                       text-align: center;
//                       "
//                     >
//                       Copyright © 2025, Lookflock
//                     </td>
//                   </tr>
//                 </table>
//               </td>
//             </tr>
//           </table>
//         </td>
//       </tr>
//     </table>
//   </body>`,
//   };

//   try {
//     const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(mailOptions),
//     });

//     const data = await response.json();
//     console.log("Email sent:", data.message);
//   } catch (error) {
//     console.error("Error sending email:", error);
//   }
// };
// const WelcomeUser = async (displayName, email) => {
//   const mailOptions = {
//     to: email,
//     subject: "Welcome to Lookflock - Social Shopping!",
//     text: `Hello ${displayName}!\n
//         Welcome to Lookflock.com, a social shopping platform for all things fashion. We are thrilled to have you onboard.\n
//         As a user, you can:\n
//         1. Discover Fashion Trends: Explore curated collections and find inspiration.\n
//         2. Create & Share Wishlists: Showcase must-haves and get personalized recommendations.\n
//         3. Connect with Our Community: Engage with fellow fashion enthusiasts, bloggers, designers, and stylists.\n
//         Please note that the site is still in development, so you might encounter some incomplete sections and broken functionality.\n
//         We encourage you to share your feedback with us here or by replying to this email, as it helps us greatly to improve our functionality and provide a better experience for our users.\n
//         Best regards,\n
//         The Lookflock Team\n
//         https://www.lookflock.com\n
//         P.S. Don't forget to complete your profile to get the most personalized experience!`,
//     html: `<p>Hello ${displayName}!</p>
//         <p>Welcome to <a href="https://www.lookflock.com">Lookflock.com</a>, a social shopping platform for all things fashion. We are thrilled to have you onboard.</p>
//         <p>As a user, you can:</p>
//         <ol>
//           <li><b>Discover Fashion Trends:</b> Explore curated collections and find inspiration.</li>
//           <li><b>Create & Share Wishlists:</b> Showcase must-haves and get personalized recommendations.</li>
//           <li><b>Connect with Our Community:</b> Engage with fellow fashion enthusiasts, bloggers, designers, and stylists.</li>
//         </ol>
//         <p>Please note that the site is still in development, so you might encounter some incomplete sections and broken functionality.</p>
//         <p>We encourage you to share your feedback with us <a href="https://www.lookflock.com/#/contactUs">here</a> or by replying to this email, as it helps us greatly to improve our functionality and provide a better experience for our users.</p>
//         <p>Best regards,<br>
//         The Lookflock Team<br>
//         <a href="https://www.lookflock.com">https://www.lookflock.com</a></p>
//         <p>P.S. Don't forget to complete your profile to get the most personalized experience!</p>`,
//   };

//   try {
//     const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(mailOptions),
//     });

//     const data = await response.json();
//     console.log("Email sent:", data.message);
//   } catch (error) {
//     console.error("Error sending email:", error);
//   }
// };
// EmailWelcomeTemplate.js

// Function to send welcome email
// Function to send welcome email
// const WelcomeUser = async (displayName, email) => {
//   const mailOptions = {
//     to: email,
//     subject: "Welcome to Lookflock - Social Shopping!",
//     text: `Hello ${displayName}!\n
//         Welcome to Lookflock.com, a social shopping platform for all things fashion. We are thrilled to have you onboard.\n
//         As a user, you can:\n
//         `,
//     html: `
// <!DOCTYPE html>
// <html lang="en">
// <head>
//   <meta charset="UTF-8">
//   <meta name="viewport" content="width=device-width, initial-scale=1.0">
//   <title>Welcome to Lookflock</title>
// </head>
// <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #FFFFFF; color: #000000; line-height: 1.4;">
//   <!-- Main Container -->
//   <div style="max-width: 600px; margin: 0 auto; background-color: #EAF0F3;">

//     <!-- Header -->
//     <div style="text-align: center; padding: 32px 20px 20px;">
//       <h1 style="margin: 0; font-size: 24px; font-weight: 400;">
//         Hello <span style="font-weight: 700; color: #000000;">${displayName}</span>,
//       </h1>
//       <h2 style="margin: 4px 0 0; font-size: 24px; font-weight: 400;">
//         Welcome to <span style="font-weight: 700; color: #000000;">Lookflock</span>
//       </h2>
//     </div>

//     <!-- White Container -->
//     <div style="background-color: #ffffff; border-radius: 8px; margin: 0 16px; overflow: hidden;">

//       <!-- Features Section -->
//       <!-- Discover Trends -->
//       <div style="background-color: #EAF0F3; margin: 16px; border-radius: 8px; padding: 16px; display: flex; align-items: center;">
//         <div style="margin-right: 16px;">
//           <div style="background-color: #f0f0f0; width: 48px; height: 48px; border-radius: 8px; position: relative; display: flex; align-items: center; justify-content: center;">
//             <img src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/emailImages%2Fdiscover.png?alt=media&token=d5a46725-802b-4ab6-9ba2-76a99819c460" width="50" height="50" alt="Discover" style="display: block;" />
//           </div>
//         </div>
//         <div>
//           <h3 style="margin: 0 0 4px; font-size: 20px; font-weight: bold;color: #000000;">Discover Trends</h3>
//           <p style="margin: 0; color: #666666; font-size: 16px;">Explore curated collections and get inspired</p>
//         </div>
//       </div>

//       <!-- Create & Share Wishlists -->
//       <div style="background-color: #EAF0F3; margin: 16px; border-radius: 8px; padding: 16px; display: flex; align-items: center;">
//         <div style="margin-right: 16px;">
//           <div style="background-color: #f0f0f0; width: 48px; height: 48px; border-radius: 8px; position: relative; display: flex; align-items: center; justify-content: center;">
//             <img src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/emailImages%2Flist.png?alt=media&token=64b59655-79e8-40a2-9b68-e32dae9144cb" width="50" height="50" alt="Discover" style="display: block;" />
//           </div>
//         </div>
//         <div>
//           <h3 style="margin: 0 0 4px; font-size: 20px; font-weight: bold;color: #000000;">Create & Share Wishlists</h3>
//           <p style="margin: 0; color: #666666; font-size: 16px;">Showcase must haves and receive recommendations</p>
//         </div>
//       </div>

//       <!-- Collaborate and Connect -->
//       <div style="background-color: #EAF0F3; margin: 16px; border-radius: 8px; padding: 16px; display: flex; align-items: center;">
//         <div style="margin-right: 16px;">
//           <div style="width: 48px; height: 48px; position: relative; display: flex; align-items: center; justify-content: center;">
//             <img src="https://firebasestorage.googleapis.com/v0/b/lookflock-test-e44e1.appspot.com/o/emailImages%2Fcolloborate.png?alt=media&token=e51b1a10-c2c8-481a-91b8-26ef990a1099" width="50" height="50" alt="Discover" style="display: block;" />
//           </div>
//         </div>
//         <div>
//           <h3 style="margin: 0 0 4px; font-size: 20px; font-weight: bold;color: #000000;">Collaborate and Connect</h3>
//           <p style="margin: 0; color: #666666; font-size: 16px;">Engage with fellow fashion Enthusiasts</p>
//         </div>
//       </div>

//       <!-- Feedback Section -->
//       <div style="padding: 16px 24px 0; text-align: center;">
//         <p style="color: #666666; margin-bottom: 20px; line-height: 1.5; font-size: 16px;">
//           We encourage you to share your feedback with us here or by replying to this email, as it helps us greatly to improve our functionality and provide a better experience for our users.
//         </p>

//         <a href="https://www.lookflock.com/#/contactUs" style="display: block; background-color: #0066cc; color: #ffffff; font-weight: bold; text-decoration: none; padding: 16px; border-radius: 8px; text-align: center; font-size: 18px; margin-bottom: 20px;">
//           Share Feedback
//         </a>

//         <p style="margin: 0 0 16px; text-align: center; line-height: 1.5; font-size: 16px;color: #666666;">
//           <span style="font-weight: bold; ">P.S.</span> Please note that the site is still in development, so you might encounter some incomplete sections and broken functionality.
//         </p>

//         <p style="margin: 0 0 8px; text-align: center; line-height: 1.5; font-size: 16px;">
//           Need help? Just reply to this email and we'll be happy to assist you.
//         </p>

//         <p style="margin: 0 0 24px; text-align: center;">
//           <a href="https://lookflock.com" style="color: #0066cc; text-decoration: none; font-size: 16px;">
//             https://lookflock.com
//           </a>
//         </p>
//       </div>

//       <!-- Footer -->
//       <div style="padding: 0 16px 16px; text-align: center;">
//         <p style="margin: 0; font-size: 14px; color: #666666;">
//           Copyright © 2025, <span style="font-weight: bold;">Lookflock</span>
//         </p>
//       </div>

//     </div>
//   </div>
// </body>
// </html>`
//   };

//   try {
//     const response = await fetch(process.env.REACT_APP_API + "/api/sendemail", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(mailOptions),
//     });
//     const data = await response.json();
//     console.log("Email sent:", data.message);
//   } catch (error) {
//     console.error("Error sending email:", error);
//   }
// };

module.exports = {
  InviteUser,
  GetFeedBack,
  WelcomeUser,
  ShoppingListMail,
  CustomShoppingListMail,
  UserMessage,
};
